/* eslint-disable camelcase */
import { useEffect } from "react";

import type { TicketEmailAutoResponseDecisionDto } from "@src/api-new/generated-api.schemas";

import type { NormalizedCustomerDto } from "@src/helpers/normalizeCustomerDto";
import ENV from "@src/constants/ENV";

interface ChatymeProps {
  customerDetails: NormalizedCustomerDto;
  token: string;
  contextValues: TicketEmailAutoResponseDecisionDto;
}

const CHATYME_BOT_ID = "cp4BZkcSIHn1Vdq8rNoyH0GFLNLyDsDs";
const CHATYME_CLIENT_APP_URL = ENV.CHATYME_CLIENT_APP_URL;
const CHATYME_CHAT_APP_URL = ENV.CHATYME_CHAT_APP_URL;

export default function Chatyme({
  customerDetails,
  token,
  contextValues
}: ChatymeProps) {

  useEffect(() => {
    (window as any).Chatyme?.init({
      client_app_url: CHATYME_CLIENT_APP_URL,
      chat_app_url: CHATYME_CHAT_APP_URL,
      chat_overlay: "client",
      config: {
        screen_type: "client",
        bot_id: CHATYME_BOT_ID,
        language: "es",
        locale: "es-ES",
        file_upload_path: `${customerDetails.id}/{{session_id}}_{{message_id}}_{{file_name}}`,
        user: {
          name: customerDetails.firstName,
          surname: customerDetails.lastName,
          email: customerDetails.email,
          role: "client",
          external_user_id: customerDetails.id
        },
        session: {
          client_profile_url: `${ENV.BACKOFFICE_URL}/customer-list/${customerDetails.id}/personal-details`
        }
      },
      env: {
        EXTERNAL_API_TOKEN: token
      },
      context: {
        ...contextValues
      }
    });

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "CHAT_TOKEN_EXPIRED") {
        // TODO: Handle token expired
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      (window as any).Chatyme?.destroy();
    };
  }, [ token, customerDetails, contextValues ]);

  return null;
}
